// extracted by mini-css-extract-plugin
export default {"connectorsContainer":"OnboardingConnectorsSkeleton_connectorsContainer__dieDo","connectorSkeleton":"OnboardingConnectorsSkeleton_connectorSkeleton__ogJAT"};